/**
 * How a service type's plans read as a table (ForServices' Plans page on a
 * computer): the series in the first column, one cell for each run of
 * plans in a row that share it, as Planning Center draws it.
 */

/**
 * For each plan, how many rows its series cell spans: the length of the run
 * at the first plan of a run of the same series, 0 for the plans under it
 * (their cell is the one above), and 1 for a plan with no series (a blank
 * cell of its own). Runs follow the list's own order, upcoming or past.
 */
export function seriesSpans(plans: readonly { series: { id: string } | null }[]): number[] {
  const spans = plans.map(() => 1)
  let start = 0
  for (let i = 1; i <= plans.length; i++) {
    const runId = plans[start]?.series?.id
    if (i < plans.length && runId !== undefined && plans[i]?.series?.id === runId) {
      spans[i] = 0
      continue
    }
    spans[start] = i - start
    start = i
  }
  return spans
}
